<!-- 社群营销-群数据分析 -->
<template>
  <div>
    <div class="head-title">数据分析</div>
    <div class="grid">
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/客户群.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日新增客户群数量</div>
        <div class="cell-2">
          {{ yesterdayData.new_chat_cnt }}
        </div>
        </div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/客户群总数量.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日客户群总数量</div>
        <div class="cell-2">
          {{ yesterdayData.chat_total }}
        </div></div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/发过消息的客户群.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日发过消息的客户群数量</div>
        <div class="cell-2">
          {{ yesterdayData.chat_has_msg }}
        </div></div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/新增群人数.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日客户群新增群人数</div>
        <div class="cell-2">
          {{ yesterdayData.new_member_cnt }}
        </div></div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/客户群 (1).png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日客户群总人数</div>
        <div class="cell-2">
          {{ yesterdayData.member_total }}
        </div></div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/发过消息的群成员数.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日有发过消息的群成员数</div>
        <div class="cell-2">
          {{ yesterdayData.member_has_msg }}
        </div></div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <img src="../../assets/客户群消息总数.png" alt="">
        </div>
        <div class="cell-right">
        <div class="cell-1">昨日客户群消息总数</div>
        <div class="cell-2">
          {{ yesterdayData.msg_total }}
        </div></div>
      </div>
    </div>
    <!-- <nav class="navbar">
      <div class="nav-l">
        <div class="block">
          <span>查询时间段：</span>
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            @change="getData"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="nav-r"></div>
    </nav> -->
    <div class="container">
      <p class="chart-title">
        <span>群数据分析 </span>
        <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            @change="getData"
          >
          </el-date-picker></p>
      <div id="myChart" class="echart" style="width: 100%; height: 62.0rem"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
let echarts = require("echarts/lib/echarts");
let ming = require("echarts/lib/echarts");
// 引入饼状图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  data() {
    return {
      time: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 8),
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 1),
      ],
      pickerOptions: {
        disabledDate: (date) => {
          const time = date.getTime();
          return (
            time > Date.now() - 3600 * 1000 * 24 * 1 &&
            time > Date.now() - 3600 * 1000 * 24 * 30
          );
        },
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      statics: [],
      yesterdayData: [],
    };
  },

  components: {},

  computed: {},
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getYesterdayData();
    this.getData();
  },

  methods: {
    async getYesterdayData() {
      const { data: res } = await this.axios({
        url: "/crm/groupMaterial/statisticGroupByDay",
        method: "POST",
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
        }),
      });
      if (res.code == 0) {
        this.$message.error(res.msg);
      } else {
        this.yesterdayData = res.data[0].data;
      }
    },
    async getData() {
      let day_begin_time = "";
      let day_end_time = "";
      if (this.time.length) {
        day_begin_time = parseInt(this.time[0].getTime() / 1000);
        day_end_time = parseInt(this.time[1].getTime() / 1000);
      }

      const { data: res } = await this.axios({
        url: "/crm/groupMaterial/statisticGroupByDay",
        method: "POST",
        data: qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          day_begin_time: day_begin_time,
          day_end_time: day_end_time,
        }),
      });
      if (res.code == 0) {
        this.$message.error(res.msg);
      } else {
        this.statics = res.data;
      }
      this.createMyChart();
    },
    createMyChart() {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      const legend_data = [
        "客户群数量",
        "客户群总数量",
        "发过消息的客户群数量",
        "新增群人数",
        "客户群总人数",
        "有发过消息的群成员数",
        "客户群消息总数",
      ];
      const xAxis_data = this.statics.map((i) => i.stat_time);
      const new_chat_cntArray = this.statics.map((i) => i.data.new_chat_cnt);
      const chat_totalArray = this.statics.map((i) => i.data.chat_total);
      const chat_has_msgArray = this.statics.map((i) => i.data.chat_has_msg);
      const new_member_cntArray = this.statics.map(
        (i) => i.data.new_member_cnt
      );
      const member_totalArray = this.statics.map((i) => i.data.member_total);
      const member_has_msgArray = this.statics.map(
        (i) => i.data.member_has_msg
      );
      const msg_totalArray = this.statics.map((i) => i.data.msg_total);
      let color = [
        // "#0090FF",
        // "#36CE9E",
        // "#FFC005",
        // "#FF515A",
        // "#8B5CFF",
        // "#00CA69",
        // "#44D7B6"
        "#49B372 ",
        "#317AF8",
        "#6C6CEA ",
        "#56C9E6",
        "#FF8F8C",
        "#FF90AD",
        "#FF925E",
      ];
      const option = {
        color,
        // title: {
        //   text: "群数据分析",
        // },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legend_data,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxis_data,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "客户群数量",
            type: "line",
            stack: "总量",
            smooth: true,
            data: new_chat_cntArray,
            areaStyle: {
                    color: "#49B372 ",
                    opacity: 0.5,
                  }
          },
          {
            name: "客户群总数量",
            type: "line",
            stack: "总量",
            smooth: true,
            data: chat_totalArray,
            areaStyle: {
                    color: "#317AF8 ",
                    opacity: 0.5,
                  }
          },
          {
            name: "发过消息的客户群数量",
            type: "line",
            stack: "总量",
            smooth: true,
            data: chat_has_msgArray,
            areaStyle: {
                    color: "#6C6CEA ",
                    opacity: 0.5,
                  }
          },
          {
            name: "新增群人数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: new_member_cntArray,
            areaStyle: {
                    color: "#56C9E6 ",
                    opacity: 0.5,
                  }
          },
          {
            name: "客户群总人数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: member_totalArray,
            areaStyle: {
                    color: "#FF8F8C ",
                    opacity: 0.5,
                  }
          },
          {
            name: "有发过消息的群成员数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: member_has_msgArray,
            areaStyle: {
                    color: "#FF90AD ",
                    opacity: 0.5,
                  }
          },
          {
            name: "客户群消息总数",
            type: "line",
            stack: "总量",
            smooth: true,
            data: msg_totalArray,
            areaStyle: {
                    color: "#FF925E ",
                    opacity: 0.5,
                  }
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style  scoped>
.main{
  padding: 2.0rem 2.5rem;
}
.navbar {
  margin-top: 1.0rem;
  margin-bottom: 2.0rem;
}
.container {

  padding:2.7rem 3.0rem;


  background: #FFFFFF;
border-radius: .8rem;
}
.grid {
  display: flex;
  flex-wrap: wrap;
}
.cell {
  width: 24%;
  height: 12.0rem;
  padding: 2.0rem ;
  /* border: .1rem solid #dcdcdc; */
  margin: 0 2.0rem 2.0rem 0;
  border-radius: .8rem;
  display: flex;
  background-color: #ffffff;

}
.cell:nth-child(4n){
  margin-right: .0rem;
}
.cell-left{
  width: 10.0rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cell-right{
  padding-left: 2.0rem;
}
.cell-1 {
  font-size: 1.8rem;
  color:#666
}
.cell-2 {
  margin-top: 1.3rem;
  font-size: 3.6rem;
  color: #333;
}
.navbar span{
  font-size: 1.8rem;
}
.chart-title{
  font-size: 2.4rem;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 3.3rem;
padding-bottom: 3rem;
display: flex;
justify-content: space-between;
}
</style>
